import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import { getEventNameWithEventType } from "components/investorrelations/utils";
import TextTooltip from "components/shared/TextTooltip";
import CalendarIcon from "components/svg/CalendarIcon";
import formatDistanceStrict from "date-fns/formatDistanceStrict";
import lightFormat from "date-fns/lightFormat";
import ptBR from "date-fns/locale/pt-BR";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { palette } from "lib/miolo";
import parseDateYmd from "lib/utils/parseDateYmd";

interface INextUpcomingCalendarEventCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment | IAmericanCompanyIssuerTopLevelFragment;
}

export default function NextUpcomingCalendarEventCard({ issuer }: INextUpcomingCalendarEventCardProps) {
  if (!issuer.nextUpcomingCalendarEvent || issuer.nextUpcomingCalendarEvent.__typename !== "EarningsResultsEvent") {
    return null;
  }

  const isAmericanIssuer = issuer.__typename === "AmericanCompanyIssuer";
  const eventDate = parseDateYmd(issuer.nextUpcomingCalendarEvent.eventDate);

  return (
    <IconCard primaryColor={palette.mojo} secondaryColor={palette.vanillaIce} icon={<CalendarIcon />}>
      <CardValue>
        <TextTooltip
          id="NextUpcomingCalendarEventCard"
          placement="top"
          content={`Daqui ${formatDistanceStrict(eventDate, new Date(), { locale: ptBR })}`}
          style={{
            maxWidth: 260,
            textAlign: "center",
          }}
        >
          {({ accessibility, bind, ref }) => (
            <span {...accessibility} {...bind} ref={ref}>
              {lightFormat(eventDate, "dd/MM/yyyy")}
            </span>
          )}
        </TextTooltip>
      </CardValue>
      <CardDescription>
        {getEventNameWithEventType(
          issuer.nextUpcomingCalendarEvent.eventType,
          issuer.nextUpcomingCalendarEvent.eventFiscalYear,
          isAmericanIssuer ? "USA" : "BRA",
        )}
      </CardDescription>
    </IconCard>
  );
}
